import React, { Fragment, useState, useEffect } from "react";

import './FamiliesTab.scss';

import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getChildAdoptedFamilyMembers} from "root/DataFunctions/FamilyDataFns";
import FamilyMemberTable from "root/Tables/FamilyMemberTable";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import useModalAddFamilyMember from "root/Modals/AddFamilyMember/useModalAddFamilyMember";

const FamilyMembersTab = (props) =>
{
    const [data, setData] = useState({ loading: true, data: [] });

    const getFamilyId = () =>
    {
        const family_id = props.match.params.family_id ;
        return family_id ;
    }

    const [ renderAddFamilyMemberModal, showAddFamilyMemberModal ] = useModalAddFamilyMember( (result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, [props.child_id]);

    const getData = () => {
        getChildAdoptedFamilyMembers(props.child_id, getFamilyId(), (response) =>
        {
            setData({ isLoading: false, data: getDataFromResponse(response)});
        });
    };

    const clickHandler = (family_member_id, mode, ) =>
    {
        showAddFamilyMemberModal(mode, props.child_id, getFamilyId(), family_member_id);
    }

    return (
        <Fragment>
            <div className="family-body">
                <FamilyMemberTable child_id={props.child_id} loading={data.loading} data={data.data} clickHandler={clickHandler}/>
                <section>
                    <ActionButton icon='icon-add' onClick={() => clickHandler(null, 'create')} title="Add Family Member"/>
                </section>
            </div>

            {renderAddFamilyMemberModal( props )}
        </Fragment>
    )
}

FamilyMembersTab.defaultProps = {};

export default FamilyMembersTab;

